import { ToastsStore } from "react-toasts";

/** Applied to react-toasts error toasts for dynamic checklist required-field validation. */
export const REQUIRED_FIELDS_TOAST_CLASS = "toast-required-fields";

const REQUIRED_FIELDS_TOAST_MS = 7000;

/**
 * Show a validation toast whose width follows the message (see style.css).
 * Lists every missing field when more than one is unfilled.
 */
export function showRequiredFieldsToast(missing: string[]): void {
  if (!missing.length) return;

  let message: string;
  if (missing.length === 1) {
    message = `Fix required fields: ${missing[0]}`;
  } else {
    message = `Fix required fields (${missing.length}):\n${missing.map((m) => `• ${m}`).join("\n")}`;
  }

  ToastsStore.error(message, REQUIRED_FIELDS_TOAST_MS, REQUIRED_FIELDS_TOAST_CLASS);
}
